import { render, staticRenderFns } from "./DispensingPermittedPreview.vue?vue&type=template&id=c57292d6"
import script from "./DispensingPermittedPreview.vue?vue&type=script&lang=js"
export * from "./DispensingPermittedPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports